import i18n, { Ti18nKeys } from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import {
  FEATURE_TAG_FONT_SIZE,
  FEATURE_TAG_HEIGHT,
  FEATURE_TAG_PADDING,
  FEATURE_TAG_RADIUS_CSS,
  FEATURE_ROW_GAP,
  FEATURE_ROW_HEIGHT,
  FEATURE_ROW_LABEL_FONT_SIZE,
  FEATURE_ROW_LABEL_WIDTH
} from "./feature-badge-row-constants";

export type TFeatureBadge = {
  tag: string;
  tagColor: string;
  tagWidth: number;
  isActive: boolean;
};

const FeatureBadgeRow = withLiteObserverAndTheme<{
  labelKey: Ti18nKeys;
  badges: TFeatureBadge[];
}>((props) => {
  const { labelKey, badges, theme } = props;
  const { colors, unitX, unitY } = theme;
  const activeBadges = badges.filter((badge) => badge.isActive);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={FEATURE_ROW_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{ width: "100%", gap: FEATURE_ROW_GAP * unitX }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={FEATURE_ROW_LABEL_WIDTH}
        height={FEATURE_ROW_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{ flexShrink: 0 }}
        onClick={() => {}}
      >
        <Et3Text
          text={i18n.get(labelKey)}
          fontFamily="MEDIUM"
          fontSize={FEATURE_ROW_LABEL_FONT_SIZE}
          color={colors.all.davysGrey}
          isSpan={true}
          style={{ margin: 0 }}
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={FEATURE_ROW_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          flex: 1,
          minWidth: 0,
          flexWrap: "wrap",
          gap: `${FEATURE_ROW_GAP * unitY}px ${FEATURE_ROW_GAP * unitX}px`
        }}
        onClick={() => {}}
      >
        {activeBadges.length > 0 ? (
          activeBadges.map((badge) => (
            <ET3Div
              key={badge.tag}
              isScrollable={false}
              isExtendable={false}
              withShadow={false}
              width={0}
              height={FEATURE_TAG_HEIGHT}
              fDirection="row"
              alignItems="center"
              justifyContent="center"
              color={colors.all.white}
              style={{
                boxSizing: "border-box",
                width: "auto",
                flexShrink: 0,
                whiteSpace: "nowrap",
                border: `1px solid ${badge.tagColor}`,
                borderRadius: FEATURE_TAG_RADIUS_CSS,
                paddingLeft: FEATURE_TAG_PADDING * unitX,
                paddingRight: FEATURE_TAG_PADDING * unitX
              }}
              onClick={() => {}}
            >
              <Et3Text
                text={badge.tag}
                fontFamily="BOLD"
                fontSize={FEATURE_TAG_FONT_SIZE}
                color={badge.tagColor}
                isSpan={true}
                style={{ margin: 0 }}
              />
            </ET3Div>
          ))
        ) : (
          <Et3Text
            text={i18n.get("NONE_ACTIVE")}
            fontFamily="LIGHT"
            fontSize={FEATURE_ROW_LABEL_FONT_SIZE}
            color={colors.all.gray}
            isSpan={true}
            style={{ margin: 0 }}
          />
        )}
      </ET3Div>
    </ET3Div>
  );
});
export default FeatureBadgeRow;
